import React from 'react';
export function SectionDivider() {
  return <div className="w-full flex justify-center py-12 md:py-20 opacity-50" data-id="element-198">
      <div className="w-24 h-[1px] bg-gradient-to-r from-transparent via-gold to-transparent" data-id="element-199" />
    </div>;
}